import request from '@/utils/request'

//展项列表查询
export function findExhibition(params) {
  return request({
    url: '/api/exhibition/exhibitionNormal/list',
    method: 'get',
    params
  });
}
//展项详情查询
export function getDetailById(params) {
  return request({
    url: '/api/elements/getDetailById',
    method: 'get',
    params
  });
}
//展区列表
export function getareaList(params) {
  return request({
    url: '/api/exhibition/exhibitionNormal/areaList',
    method: 'get',
    params
  });
}

//语音详情
export function getvoiceInfo(id) {
  return request({
    url: '/content/contenvoiceguide/info/'+id,
    method: 'get'
  });
}


//展品列表
export function getNormallist(params) {
  return request({
    url: '/api/exhibition/exhibitionNormal/list',
    method: 'get',
    params
  });
}
//展品详情
export function getNormalInfo(params) {
  return request({
    url: '/api/exhibition/exhibitionNormal/info',
    method: 'get',
    params
  });
}

// 展项点赞
export function getzxLiked(params) {
  return request({
    url: '/api/exhibition/exhibitionliked/list',
    method: 'get',
    params
  });
}
// 添加行程
export function addtravelitinerary(data) {
  return request({
    url: '/api/travelitinerary/save',
    method: 'post',
    data
  });
}
// 取消行程
export function deletetravelitinerary(data) {
  return request({
    url: '/api/travelitinerary/delete',
    method: 'post',
    data
  });
}
// 获取我的个人行程单
export function getMyTravelItinerary(params) {
  return request({
    url: '/api/travelitinerary/getMyTravelItinerary',
    method: 'get',
    params
  });
}
// 行程单坐标
export function getExhibitionArea(params) {
  return request({
    url: '/api/travelitinerary/getExhibitionArea',
    method: 'get',
    params
  });
}
// 展品分享
export function shared(params) {
  return request({
    url: '/api/exhibition/exhibitionNormal/shared',
    method: 'get',
    params
  });
}
// 科技精粹
export function getessencelist(params) {
  return request({
    url: '/api/exhibition/exhibitionNormal/list',
    method: 'get',
    params
  });
}
export function getexhibitionArea(params) {
  return request({
    url: 'api/exhibition/exhibitionArea/all',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/knowledge/index.js